import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class UploadApiService extends APIServiceBase {
    constructor() {
        super('Upload')
    }

    upload(files, progressCallback) {
        let formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            formData.append('files', file);
        }

        return this.sendRequest('Upload', 'POST', formData, false, {
            onUploadProgress: progressCallback
        })
    }
}

registerAPIService(UploadApiService)